import http from "src/_services/httpService";
import { $BASE_URL } from "src/constants";

const apiUrl = `${$BASE_URL}/api/v1/warehouse`;


const createWarehouse = (payload) => {
    return http.post(`${apiUrl}`, payload);
}
const updateWarehouse = (payload) => {
    return http.post(`${apiUrl}/update`, payload);
}
const getWarehouses = (params) => {
    return http.get(`${apiUrl}`, { params });
}
const getWarehousesByFilter = ({ limit = 50, page = 1, merchant, searchKey }) => {
    return http.get(`${apiUrl}/filter?page=${page}&limit=${limit}&merchant=${merchant}${searchKey ? `&searchKey=${searchKey}` : ''}`);
}
const getWarehouseById = (id) => {
    return http.get(`${apiUrl}/${id}`);
}
const deleteWarehouse = (id) => {
    return http.delete(`${apiUrl}/${id}`);
}

const WarehouseService = {
    createWarehouse,
    updateWarehouse,
    getWarehouses,
    getWarehouseById,
    deleteWarehouse,
    getWarehousesByFilter
};

export default WarehouseService;
